<template>
    <div class="cont-table">

        <div class="spin">
            <ion-spinner name="crescent"></ion-spinner>
        </div>

        <div class="row cont_cespiti_admin_ok">
            <div class=" " style="margin:0 auto;">
                <div class="card">

                    <div class="card-body" style="padding:0px">

                        <div class="table-responsive" style="">

                            <table id="myTable" style="margin-top:57px">
                                <thead>
                                    <tr>


                                        <th class='all'>
                                            <div class="cl_checkall">
                                                <ion-checkbox name='emailgestoreall' class='checkall' slot='start'
                                                    style="width:10px!important;height:10px!important">
                                                </ion-checkbox>
                                            </div>
                                        </th>

                                        <th class='all'>
                                            <div class='cl_num'>N.</div>
                                        </th>
                                        <th class='all'>Surname</th>
                                        <th class='all'>Name</th>
                                        <th class='all'>Type</th>
                                        <th class='all'>Description</th>
                                        <th class='all'>
                                            <div class="cl_office_lic">Office Lic.</div>
                                        </th>
                                        <th class='all'>Location</th>
                                        <th class='all' style="text-align: center;">Rental</th>
                                        <th class='all'>Delivered</th>
                                        <th class='all'>Redelivery</th>
                                        <th class='all' style="text-align:center">Status</th>
                                        <th class='all' style="text-align:center">Signed</th>
                                        <th class='all' style="text-align:center">Attachment</th>
                                        <th class='all' style="text-align:center">
                                            <div class="cl_date_inv">Date Invite</div>
                                        </th>

                                    </tr>
                                </thead>

                                <tfoot>

                                    <tr>
                                        <th colspan="15">
                                        </th>
                                    </tr>
                                </tfoot>

                            </table>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="text-left">
            <v-bottom-sheet v-model="sheetChangeStatus">
                <v-sheet class="text-center" height="340px" style="padding-bottom:120px;">
                    <v-btn class='closeStatusSheet' icon @click="sheetChangeStatus = !sheetChangeStatus">

                        <v-img alt="Proprietario Logo" class="  " contain src="@/assets/btn_cancel3_emt.png"
                            max-width="24" max-height="24" style="margin-right:13px" transition="scale-transition" />
                    </v-btn>
                    <div class="py-3">
                        Seleziona stato
                    </div>
                    <v-list-item v-for="tile in allStatus" :key="tile.title" @click="changeStatusAdmin(tile.title)">
                        <v-list-item-avatar>
                            <v-avatar size="32px" tile>
                                <v-icon :color="tile.color">{{ tile.icon }}</v-icon>
                            </v-avatar>
                        </v-list-item-avatar>
                        <v-list-item-title style="justify-content: center;text-align: left;">{{
                            tile.title
                            }}</v-list-item-title>
                    </v-list-item>
                </v-sheet>
            </v-bottom-sheet>
        </div>

        <div class="text-left">
            <v-bottom-sheet v-model="sheetStatus">
                <v-sheet class="text-center" height="385px" style="padding-bottom:120px;">
                    <v-btn class='closeStatusSheet' icon @click="sheetStatus = !sheetStatus">

                        <v-img alt="Proprietario Logo" class="  " contain src="@/assets/btn_cancel3_emt.png"
                            max-width="24" max-height="24" style="margin-right:13px" transition="scale-transition" />
                    </v-btn>
                    <div class="py-3">
                        Seleziona stato
                    </div>
                    <v-list-item v-for="tile in allStatusFilter" :key="tile.title" @click="changeStatus(tile.id)">
                        <v-list-item-avatar>

                            <v-avatar size="25px" tile>

                                <v-img alt="" contain :src="tile.img" :max-width="tile.width"
                                    :max-height="tile.height" />

                            </v-avatar>

                        </v-list-item-avatar>

                        <v-list-item-title style="text-align:left!important;font-size:9px!important">{{
                            tile.title
                            }}</v-list-item-title>

                    </v-list-item>
                </v-sheet>
            </v-bottom-sheet>
        </div>


        <div class="contaziende">

            <template>
                <div class="text-center">
                    <v-bottom-sheet v-model="sheetAziende" class="vaziendesheet" style="z-index:9999">
                        <v-sheet class="text-center" height="100vh">
                            <div class="headerSheetAziende" fixed style="position:fixed;">
                                Aziende
                                <v-btn class='closeSheet align_close_sheet' icon @click="sheetAziende = !sheetAziende">

                                    <v-img alt="Proprietario Logo" class="  " contain src="@/assets/btn_cancel3_emt.png"
                                        max-width="24" max-height="24" style="margin-right:13px"
                                        transition="scale-transition" />

                                </v-btn>

                                <v-toolbar>
                                    <v-text-field hide-details prepend-icon="mdi-magnify" single-line v-model="search">
                                    </v-text-field>

                                </v-toolbar>

                            </div>

                            <v-divider></v-divider>

                            <div class="spacer" style="min-height:72px;"></div>

                            <v-flex xs12 sm12>
                                <v-card>

                                    <v-list-item class="text-left" v-for="item in filteredAziende" :key="item.companyid"
                                        @click="manageClickAziende(item)">

                                        <v-img alt="" src="@/assets/aziende-emt.png" max-width="24" max-height="24" />

                                        <v-list-item-title class='itemAzienda'>{{ item.fld_name }}</v-list-item-title>

                                    </v-list-item>

                                    <div style="min-height:150px;height:150px">&nbsp;</div>

                                </v-card>
                            </v-flex>
                        </v-sheet>
                    </v-bottom-sheet>
                </div>
            </template>
        </div>

        <div class="contpopupdatefrom" style="display:none">

            <template>
                <modal name="popupDateFrom" :clickToClose="false" :width="300" :height="400">


                    <v-row>

                        <v-col cols="12" md="12" style="margin-top:10px!important;font-weight:bold;margin-left:10px">

                            Periodo

                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12" style="margin-top:10px!important">

                            <v-menu v-model="showPicker3" :close-on-content-click="false" transitions="scale-transition"
                                offset-y max-width="290px" min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field id="fldInpDataDa" v-model="dataDa" label="Da" persistent-hint readonly
                                        v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="dataDa" no-title @input="showPicker3 = false" locale="it">
                                </v-date-picker>
                            </v-menu>

                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12" style="margin-top:10px!important">

                            <v-menu v-model="showPicker4" :close-on-content-click="false" transitions="scale-transition"
                                offset-y max-width="290px" min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field id="fldInpDataA" v-model="dataA" label="A" persistent-hint readonly
                                        v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="dataA" no-title @input="showPicker4 = false" locale="it">
                                </v-date-picker>
                            </v-menu>

                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12">

                            <div style="display:flex;justify-content:center">

                                <v-img alt="" class="btn-cancel-date-from" contain src="@/assets/btn_cancel3_emt.png"
                                    max-width="30" max-height="30" style="cursor:pointer;color:black;margin-right:10px"
                                    transition="scale-transition" title="Annulla" />


                                <v-img alt="" class="btn-reset-date-from" contain src="@/assets/reset.png"
                                    max-width="25" max-height="25"
                                    style="cursor:pointer;margin-right:10px;margin-top:3px"
                                    transition="scale-transition" title="Pulisci" />

                                <v-img alt="" class="btn-confirm-date-from" contain src="@/assets/btn_confirm3_emt.png"
                                    max-width="32" max-height="32" style="cursor:pointer" transition="scale-transition"
                                    title="Conferma" />

                            </div>

                        </v-col>

                    </v-row>

                </modal>
            </template>

        </div>

        <div class="contpopupsearch" style="display:none">

            <template>
                <modal name="popupSearch" :clickToClose="false" :width="262" :height="555">


                    <v-row>

                        <v-col cols="12" md="12" style="margin-top:10px!important;font-weight:bold;margin-left:10px">

                            Filtri

                        </v-col>

                    </v-row>

                    <v-row
                        style="margin-bottom: 0px!important;margin-top:0px!important;padding-bottom: 0px!important;padding-top:0px!important;">

                        <v-col cols="12" md="12"
                            style="margin-bottom: 0px!important;margin-top:0px!important;padding-bottom: 0px!important;padding-top:0px!important;">

                            <v-text-field v-model="textSearch" label="Cerca testo">
                            </v-text-field>

                        </v-col>

                    </v-row>

                    <v-row
                        style="margin-bottom: 0px!important;padding-bottom: 0px!important;margin-top:0px!important;padding-top: 0px!important">

                        <v-col cols="12" md="12"
                            style="margin-bottom: 0px!important;padding-bottom: 0px!important;margin-top:0px!important;padding-top: 0px!important">

                            <div id="cont_status" style="cursor:pointer">
                                <ion-item id="itemCompany"
                                    style="min-width:190px!important;transform: translateX(-6px);margin-top:-24px;margin-bottom:18px">

                                    <ion-label style="font-size:12px;color:gray!important;opacity:1;cursor:pointer"
                                        position="floating">Stato </ion-label>

                                    <ion-select id="stato" name="stato" class='stato' cancel-Text="Chiudi" done-Text=""
                                        :value="filterStato" interface="action-sheet">

                                        <ion-select-option v-for="item in allStatusFilter" :key="item.id"
                                            :value='item.id'> {{
                                                item.title }}</ion-select-option>

                                    </ion-select>
                                </ion-item>
                            </div>

                        </v-col>

                    </v-row>

                    <v-row
                        style="margin-bottom: 0px!important;padding-bottom: 0px!important;margin-top:0px!important;padding-top: 0px!important">

                        <v-col cols="12" md="12"
                            style="margin-bottom: 0px!important;padding-bottom: 0px!important;margin-top:0px!important;padding-top: 0px!important">

                            <v-menu v-model="showPicker3" :close-on-content-click="false" transitions="scale-transition"
                                offset-y max-width="290px" min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field id="fldInpDataDa" v-model="dataDa" label="Da" persistent-hint readonly
                                        v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="dataDa" no-title @input="showPicker3 = false" locale="it">
                                </v-date-picker>
                            </v-menu>

                        </v-col>

                    </v-row>

                    <v-row
                        style="margin-bottom: 0px!important;padding-bottom: 0px!important;margin-top:0px!important;padding-top: 0px!important">

                        <v-col cols="12" md="12"
                            style="margin-bottom: 0px!important;padding-bottom: 0px!important;margin-top:0px!important;padding-top: 0px!important">

                            <v-menu v-model="showPicker4" :close-on-content-click="false" transitions="scale-transition"
                                offset-y max-width="290px" min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field id="fldInpDataA" v-model="dataA" label="A" persistent-hint readonly
                                        v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="dataA" no-title @input="showPicker4 = false" locale="it">
                                </v-date-picker>
                            </v-menu>

                        </v-col>

                    </v-row>


                    <v-row
                        style="margin-bottom: 0px!important;padding-bottom: 0px!important;margin-top:0px!important;padding-top: 0px!important">

                        <v-col cols="12" md="12"
                            style="margin-bottom: 0px!important;padding-bottom: 0px!important;margin-top:0px!important;padding-top: 0px!important">

                            <div id="cont_status" style="cursor:pointer">
                                <ion-item id="itemCompany"
                                    style="min-width:190px!important;transform: translateX(-6px);margin-top:-24px;margin-bottom:18px">

                                    <ion-label style="font-size:12px;color:gray!important;opacity:1;cursor:pointer"
                                        position="floating">Noleggio </ion-label>

                                    <ion-select id="noleggio" name="noleggio" class='noleggio' cancel-Text="Chiudi"
                                        done-Text="" :value="filterNoleggio" interface="action-sheet">

                                        <ion-select-option v-for="item in noleggio" :key="item.id" :value='item.id'> {{
                                            item.nome }}</ion-select-option>

                                    </ion-select>
                                </ion-item>
                            </div>

                        </v-col>

                    </v-row>

                    <v-row
                        style="margin-bottom: 0px!important;padding-bottom: 0px!important;margin-top:0px!important;padding-top: 0px!important">

                        <v-col cols="12" md="12"
                            style="margin-bottom: 0px!important;padding-bottom: 0px!important;margin-top:0px!important;padding-top: 0px!important">

                            <div id="cont_status" style="cursor:pointer">
                                <ion-item id="itemCompany"
                                    style="min-width:190px!important;transform: translateX(-6px);margin-top:-24px;margin-bottom:18px">

                                    <ion-label style="font-size:12px;color:gray!important;opacity:1;cursor:pointer"
                                        position="floating">Firma </ion-label>

                                    <ion-select id="firma" name="firma" class='firma' cancel-Text="Chiudi" done-Text=""
                                        :value="filterFirma" interface="action-sheet">

                                        <ion-select-option v-for="item in firma" :key="item.id" :value='item.id'> {{
                                            item.nome }}</ion-select-option>

                                    </ion-select>
                                </ion-item>
                            </div>

                        </v-col>

                    </v-row>

                    <v-row
                        style="margin-bottom: 0px!important;padding-bottom: 0px!important;margin-top:0px!important;padding-top: 0px!important">

                        <v-col cols="12" md="12"
                            style="margin-bottom: 0px!important;padding-bottom: 0px!important;margin-top:0px!important;padding-top: 0px!important">

                            <div id="cont_status" style="cursor:pointer">
                                <ion-item id="itemCompany"
                                    style="min-width:190px!important;transform: translateX(-6px);margin-top:-24px;margin-bottom:18px">

                                    <ion-label style="font-size:12px;color:gray!important;opacity:1;cursor:pointer"
                                        position="floating">Licenza Office </ion-label>

                                    <ion-select id="licenzaoffice" name="licenzaoffice" class='licenzaoffice'
                                        cancel-Text="Chiudi" done-Text="" :value="filterLicenzaOffice"
                                        interface="action-sheet">

                                        <ion-select-option v-for="item in licenza_office" :key="item.id"
                                            :value='item.id'> {{
                                                item.nome }}</ion-select-option>

                                    </ion-select>
                                </ion-item>
                            </div>

                        </v-col>

                    </v-row>


                    <v-row>

                        <v-col cols="12" md="12">

                            <div style="display:flex;justify-content:center">

                                <v-img alt="" class="btn-cancel-search" contain src="@/assets/btn_cancel3_emt.png"
                                    max-width="30" max-height="30" style="cursor:pointer;color:black;margin-right:10px"
                                    transition="scale-transition" title="Annulla" @click="btnCancelSearch" />

                                <v-img alt="" class="btn-delete-search" contain src="@/assets/reset-iemt.png"
                                    max-width="35" max-height="35" style="cursor:pointer;color:black;margin-right:10px"
                                    transition="scale-transition" title="Elimina Filtri" @click="btnResetSearch" />


                                <v-img alt="" class="btn-confirm-search" contain src="@/assets/btn_confirm3_emt.png"
                                    max-width="30" max-height="30" style="cursor:pointer" transition="scale-transition"
                                    title="Conferma" @click="btnConfirmSearch" />


                            </div>

                        </v-col>

                    </v-row>

                </modal>
            </template>

        </div>


        <div class="text-left">
            <v-bottom-sheet v-model="sheetAssegnamento">
                <v-sheet class="text-center" height="302px" style="padding-bottom:120px;">
                    <v-btn class='closeStatusSheet' icon @click="sheetAssegnamento = !sheetAssegnamento">

                        <v-img alt="Proprietario Logo" style="margin-right:23px" class="  " contain
                            src="@/assets/btn_cancel3_emt.png" max-width="24" max-height="24"
                            transition="scale-transition" />

                    </v-btn>
                    <div class="py-3">
                        Seleziona Assegnamento
                    </div>
                    <v-list-item v-for="tile in assegnamenti" :key="tile.id" @click="filterAssegnati(tile.id)">

                        <v-list-item-title style="justify-content: center;text-align: left;">{{
                            tile.title
                            }}</v-list-item-title>
                    </v-list-item>
                </v-sheet>
            </v-bottom-sheet>
        </div>



        <div class="contpopupmailinvito" style="display:none">

            <template>
                <modal name="popupMailInvito" :clickToClose="false" :width="300" :height="500">


                    <v-row>

                        <v-col cols="12" md="12"
                            style="margin-top:10px!important;font-weight:bold;margin-left:10px;font-size: 11px;color:black">

                            Anteprima Mail Invito

                        </v-col>

                    </v-row>

                    <v-row style="margin-left:5px!important">

                        <v-col cols="12" md="12">

                            <textarea id="sec_body" name="sec_body" class="sec_body" autofocus
                                style="width:270px!important;height:400px!important"></textarea>

                        </v-col>

                    </v-row>



                    <v-row>

                        <v-col cols="12" md="12">

                            <div style="display:flex;justify-content:center">

                                <v-img alt="" class="btn-cancel-send-mail" contain src="@/assets/btn_cancel3_emt.png"
                                    max-width="30" max-height="30" style="cursor:pointer;color:black;margin-right:10px"
                                    transition="scale-transition" title="Annulla" @click="btnCancelSendMail" />

                                <v-img alt="" class="btn-confirm-send-mail" contain src="@/assets/btn_confirm3_emt.png"
                                    max-width="30" max-height="30" style="cursor:pointer" transition="scale-transition"
                                    title="Conferma" @click="btnConfirmSendMail" />


                            </div>

                        </v-col>

                    </v-row>

                </modal>
            </template>

        </div>


        <div class="contpopupmailinvitononass" style="display:none">

            <template>
                <modal name="popupMailInvitoNonAss" :clickToClose="false" :width="300" :height="588">


                    <v-row>

                        <v-col cols="12" md="12"
                            style="margin-top:10px!important;font-weight:bold;margin-left:10px;font-size: 11px;color:black">

                            Anteprima Mail Invito

                        </v-col>

                    </v-row>


                    <v-row style="margin-left:5px!important">

                        <v-col cols="12" md="12">

                            <div id="cont_materialeid" style="cursor:pointer">
                                <ion-item id="itemAzienda"
                                    style="min-width:190px!important;transform: translateX(-6px);margin-top:-8px;margin-bottom:18px">

                                    <ion-label
                                        style="font-size:11px;color:black!important;cursor:pointer;font-weight:bold;opacity:1"
                                        position="floating">Tipologia Materiale </ion-label>

                                    <ion-select id="materialeid" name="materialeid" class='materialeid'
                                        cancel-Text="Chiudi" done-Text="" :value="selMateriale"
                                        interface="action-sheet">

                                        <ion-select-option v-for="item in tipi_materiale" :key="item.id"
                                            :value='item.id'> {{ item.description }}</ion-select-option>

                                    </ion-select>
                                </ion-item>
                            </div>


                        </v-col>

                    </v-row>





                    <v-row style="margin-left:5px!important">

                        <v-col cols="12" md="12">

                            <textarea id="sec_body" name="sec_body" class="sec_body" autofocus
                                style="width:270px!important;height:400px!important"></textarea>

                        </v-col>

                    </v-row>



                    <v-row>

                        <v-col cols="12" md="12">

                            <div style="display:flex;justify-content:center">

                                <v-img alt="" class="btn-cancel-send-mail-non-ass" contain
                                    src="@/assets/btn_cancel3_emt.png" max-width="30" max-height="30"
                                    style="cursor:pointer;color:black;margin-right:10px" transition="scale-transition"
                                    title="Annulla" @click="btnCancelSendMailNonAss" />

                                <v-img alt="" class="btn-confirm-send-mail-non-ass" contain
                                    src="@/assets/btn_confirm3_emt.png" max-width="30" max-height="30"
                                    style="cursor:pointer" transition="scale-transition" title="Conferma"
                                    @click="btnConfirmSendMailNonAss" />


                            </div>

                        </v-col>

                    </v-row>

                </modal>
            </template>

        </div>





        <div class="contpopupdisassocresource" style="display:none">

            <template>
                <modal name="popupDisassocResource" :clickToClose="false" :width="262" :height="204">


                    <v-row>

                        <v-col cols="12" md="12" style="margin-top:10px!important;font-weight:bold;margin-left:10px">

                            Disassocia Risorsa

                        </v-col>

                    </v-row>


                    <v-row>

                        <v-col cols="12" md="12">

                            <v-menu v-model="showPicker" :close-on-content-click="false" transitions="scale-transition"
                                offset-y max-width="290px" min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field id="fldInpData" v-model="dataRiconsegna" label="Riconsegnato Il"
                                        persistent-hint readonly v-on="on"
                                        style="font-size:12px!important"></v-text-field>
                                </template>
                                <v-date-picker v-model="dataRiconsegna" no-title @input="showPicker = false"
                                    locale="it">
                                </v-date-picker>
                            </v-menu>

                        </v-col>

                    </v-row>



                    <v-row>

                        <v-col cols="12" md="12">

                            <div style="display:flex;justify-content:center">

                                <v-img alt="" class="btn-cancel-assoc-resource" contain
                                    src="@/assets/btn_cancel3_emt.png" max-width="30" max-height="30"
                                    style="cursor:pointer;color:black;margin-right:10px" transition="scale-transition"
                                    title="Annulla" @click="btnCancelDisassocResource" />


                                <v-img alt="" class="btn-confirm-assoc-resource" contain
                                    src="@/assets/btn_confirm3_emt.png" max-width="30" max-height="30"
                                    style="cursor:pointer" transition="scale-transition" title="Conferma"
                                    @click="btnConfirmDisassocResource" />


                            </div>

                        </v-col>

                    </v-row>

                </modal>
            </template>

        </div>

        <div class="text-left">
            <v-bottom-sheet v-model="sheetNoleggio">
                <v-sheet class="text-center" height="291px" style="padding-bottom:120px;">
                    <v-btn class='closeStatusSheet' icon @click="sheetNoleggio = !sheetNoleggio">

                        <v-img alt="Proprietario Logo" style="margin-right:23px" class="  " contain
                            src="@/assets/btn_cancel3_emt.png" max-width="24" max-height="24"
                            transition="scale-transition" />

                    </v-btn>
                    <div class="py-3">
                        Seleziona noleggio
                    </div>
                    <v-list-item v-for="tile in noleggio" :key="tile.id" @click="filterNoleggio(tile.id)">
                        <v-list-item-title style="justify-content: center;text-align: left;">{{
                            tile.nome
                            }}</v-list-item-title>
                    </v-list-item>
                </v-sheet>
            </v-bottom-sheet>
        </div>


        <div class="text-left">
            <v-bottom-sheet v-model="sheetFirma">
                <v-sheet class="text-center" height="291px" style="padding-bottom:120px;">
                    <v-btn class='closeStatusSheet' icon @click="sheetFirma = !sheetFirma">

                        <v-img alt="Proprietario Logo" style="margin-right:23px" class="  " contain
                            src="@/assets/btn_cancel3_emt.png" max-width="24" max-height="24"
                            transition="scale-transition" />

                    </v-btn>
                    <div class="py-3">
                        Seleziona firma
                    </div>
                    <v-list-item v-for="tile in firma" :key="tile.id" @click="filterFirma(tile.id)">
                        <v-list-item-title style="justify-content: center;text-align: left;">{{
                            tile.nome
                            }}</v-list-item-title>
                    </v-list-item>
                </v-sheet>
            </v-bottom-sheet>
        </div>


        <div class="contpopupviewfilepdf" style="display:none">

            <template>
                <modal name="popupViewFilePdf" id="pViewFilePdf" :clickToClose="false" :width="1651" :height="600">


                    <v-row>

                        <v-col cols="12" md="12" style="margin-top:10px!important;font-weight:bold;margin-left:10px">

                            Vedi Allegato

                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12" style="display: flex;
justify-items: center;
justify-content: center;
align-items: center;">

                            <div style="width: 94%;height: 50vh;overflow-y: auto;overflow-x: auto;">

                                <div id="container-view-pdf"></div>

                            </div>


                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12">

                            <div style="display:flex;justify-content:center">

                                <v-img alt="" class="btn-cancel-otp-delete" contain src="@/assets/btn_cancel3_emt.png"
                                    max-width="30" max-height="30" style="cursor:pointer;color:black;margin-right:10px"
                                    transition="scale-transition" title="Cancel" @click="btnCancelViewFilePdf" />


                            </div>

                        </v-col>

                    </v-row>

                </modal>
            </template>

        </div>




    </div>
</template>

<script>
import apicespiti from "../utils/cespiti/apicespiti";

import {
    bus
} from "../main";
import router from ".././router";

import * as pdfjsLib from 'pdfjs-dist';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';

import 'datatables.net'

import 'datatables.net-responsive'

import 'datatables.net-fixedheader'

import '../assets/datatables/dataTables.dataTables.css'
import '../assets/datatables/responsive.dataTables.css'
import '../assets/datatables/fixedHeader.dataTables.css'

import $ from 'jquery';

$.fn.numberFormat = function (decimals = 2, decPoint = ',', thousandsSep = '.') {
    return this.each(function () {
        let raw = $(this).text().trim()

        // Converti da "4.468,20" o "4468,2" a "4468.2"
        let val = raw.replace(/\./g, '').replace(',', '.')

        if (!isFinite(val)) return

        let n = parseFloat(val)
        let fixed = n.toFixed(decimals)

        let parts = fixed.split('.')
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep)
        let formatted = parts.join(decPoint)

        $(this).text(formatted)
    })
}


export default {
    destroyed() {
        this.$root.$children[0].bnavbuttons = [];

        bus.$off("bottomIconClickEvent");
    },

    mounted: function () {

        /*eslint-disable no-undef*/


        var pointerVue = this;

        this.$root.$children[0].checkLogout();


        window.curSrcText = "";
        window.curCompany = window.$cookies.get("sel_filter_azienda_cespiti_admin");

        pointerVue.filterAzienda = window.$cookies.get("sel_filter_azienda_cespiti_admin");

        window.curAss = "";
        window.curNoleggio = "";
        window.curFirma = "";
        window.licenzaOffice = "";


        window.perpage = 100;
        bus.$off("bottomIconClickEvent");

        window.curStatus = "-1";

        $(document).ready(
            function () {

                $("body").off();

                window.uname = window.$cookies.get("username");
                var uname = window.uname;

                const args = [uname, true, ['bar', 5], {
                    foo: 'baz'
                }];
                try {
                    console.log("entering user");
                    window.flutter_inappwebview.callHandler('setLoggedUser', ...args);
                    console.log("passed");

                } catch (error) {
                    // alert(error);
                }

            }
        );


        $(document).ready(function () {

            $('body').on('ionChange', '.licenzaoffice', function () {

                console.log("MATERIALEID");

                pointerVue.filterLicenzaOffice = this.value;

            });



            $('body').on('click', '.selnoleggio', function () {


                pointerVue.sheetNoleggio = true;

            });

            $('body').on('click', '.selfirma', function () {


                pointerVue.sheetFirma = true;

            });


            $('body').on('ionChange', '.stato', function () {

                console.log("MATERIALEID");

                pointerVue.filterStato = this.value;

            });


            $('body').on('ionChange', '.noleggio', function () {

                console.log("MATERIALEID");

                pointerVue.filterNoleggio = this.value;

            });


            $('body').on('ionChange', '.firma', function () {

                console.log("MATERIALEID");

                pointerVue.filterFirma = this.value;

            });



            $('body').on('ionChange', '#materialeid', function () {

                console.log("MATERIALEID");

                pointerVue.selMateriale = this.value;

            });




            $('body').on('click', '.selaggiorna', function () {

                pointerVue.showSpinner = true;
                pointerVue.$root.$children[0].showProgress = true;

                window.table.ajax.reload();

            });



            $('body').on('click', '.selazienda', function () {

                console.log(("EVENTO CLICK SELAZIENDA"));

                pointerVue.sheetAziende = true;

            });


            $('body').on('click', '.selstato', function () {

                console.log(("EVENTO CLICK SELSTATO"));

                pointerVue.sheetStatus = true;

            });



            $('body').on('click', '#footer-link', function (event) {
                event.preventDefault();

                const args = [1, true, ['bar', 5], {
                    foo: 'baz'
                }];
                window.flutter_inappwebview.callHandler('openLcHandler', ...args);

                return false;
            });

            $('body').on('click', '#privacy-link', function (event) {
                event.preventDefault();

                const args = [1, true, ['bar', 5], {
                    foo: 'baz'
                }];
                window.flutter_inappwebview.callHandler('openPrivacyHandler', ...args);

                return false;
            });

            $('body').on('click', '#hdtool-link', function (event) {
                event.preventDefault();

                const args = [1, true, ['bar', 5], {
                    foo: 'baz'
                }];
                window.flutter_inappwebview.callHandler('openHdHandler', ...args);

                return false;
            });


            $('body').on('click', '.seldata', function (event) {
                console.log(event);


                $(".contpopupdatefrom").show();

                pointerVue.$modal.show('popupDateFrom');



            });

            $('body').on('click', '.btn-cancel-date-from', function (event) {
                console.log(event);

                pointerVue.$modal.hide('popupDateFrom');

            });

            $('body').on('click', '.btn-reset-date-from', function (event) {
                console.log(event);

                pointerVue.dataDa = null;
                pointerVue.dataA = null;


            });


            $('body').on('click', '.btn-confirm-date-from', function (event) {
                console.log(event);

                window.dataDa = pointerVue.dataDa;
                window.dataA = pointerVue.dataA;

                pointerVue.$modal.hide('popupDateFrom');

                pointerVue.showSpinner = true;
                pointerVue.$root.$children[0].showProgress = true;

                window.table.ajax.reload();


            });


            $('body').on('click', '.checkall', function () {


                $(".val_status").prop("checked", $(this).prop("checked"));

                console.log("CHECKALL: ", $(this).prop("checked"));


                if ($(this).prop("checked")) {

                    $("tr").addClass("active-row");

                    $("tr").eq(0).removeClass("active-row");

                }

                if (!$(this).prop("checked")) {

                    $("tr").removeClass("active-row");


                }

                pointerVue.hideShowButtonsSelRow();


            });




        });

        $(window).resize(function () {


            pointerVue.centerPopupViewFilePdf();


        });


        setTimeout(() => {

            this.syncAziende();

        }, 100);


        bus.$on("bottomIconClickEvent", (data) => {
            //this.header = data;

            var ids = "";

            console.log(data);
            switch (data) {

                case "btn_delete":

                    this.deleteRow();

                    break;


                case "btn_add":
                    router.push({
                        path: "/editCespitiAdmin/0"
                    });
                    break;

                case "btn_send_invite":


                    this.sendInvite();

                    break;

                case "btn_edit":


                    ids = "";

                    $(".val_status").each(function (index) {

                        console.log(index);

                        if ($(this).prop("checked")) {

                            if (ids != "") {
                                ids = ids + ",";
                            }
                            ids = ids + $(this).attr("data-id");
                        }

                    });

                    console.log("IDS SEL:", ids);


                    router.push({
                        path: "/editCespitiAdmin/" + ids
                    });

                    break;

                case "btn_back":


                    router.push({
                        path: "/filterCespitiAdmin"
                    });


                    break;

                case "btn_copy":

                    ids = "";

                    $(".val_status").each(function (index) {

                        console.log(index);

                        if ($(this).prop("checked")) {

                            if (ids != "") {
                                ids = ids + ",";
                            }
                            ids = ids + $(this).attr("data-id");
                        }

                    });

                    console.log("IDS SEL:", ids);


                    router.push({
                        path: "/copyCespitiAdmin/" + ids
                    });



                    break;

                case "btn_download":

                    this.downAllegato();

                    break;


                case "btn_disassocia":

                    this.openPopupDisassociaRisorsa();

                    break;


                case "btn_view":

                    this.viewAllegato();

                    break;




                default:
                    break;

            }
        });



        this.setupButtonsGrid();

        window.start = 0;

        pointerVue.setupGrid();

        this.hideShowButtons(false);

        setTimeout(() => {

            $('thead th:first div span').addClass('no-before');

            $('#myTable tbody tr td:nth-child(2)').attr('style', 'padding-right:31px !important;');

        }, 500);


    },
    data: () => ({

        filterLicenzaOffice: "",

        filterNoleggio: "",

        filterFirma: "",

        filterAzienda: "",

        sheetFirma: false,

        firma: [
            {
                id: "",
                nome: "Tutti"
            },
            {
                id: "S",
                nome: "Si"
            },
            {
                id: "N",
                nome: "No"
            }
        ],

        licenza_office: [
            {
                id: "",
                nome: "Tutti"
            },
            {
                id: "S",
                nome: "Si"
            },
            {
                id: "N",
                nome: "No"
            }
        ],



        pdfUrl: "",

        sheetNoleggio: false,

        noleggio: [
            {
                id: "",
                nome: "Tutti"
            },
            {
                id: "S",
                nome: "Si"
            },
            {
                id: "N",
                nome: "No"
            }
        ],

        dataRiconsegna: null,

        tipi_materiale: [
            {
                id: 8, description: "Altro",
            },
            {
                id: 4, description: "Cable",
            },
            {
                id: 1, description: "Desktop",
            },
            {
                id: 10, description: "Disco",
            },
            {
                id: 9, description: "Memoria",
            },
            {
                id: 2, description: "Notebook",
            },
            {
                id: 11, description: "Schermo",
            },
            {
                id: 6, description: "Sim & Number",
            },
            {
                id: 5, description: "Smartphone",
            },
            {
                id: 3, description: "Software Licence",
            },
            {
                id: 7, description: "Vettura aziendale",
            },

        ],


        selMateriale: "",

        assegnamenti: [{
            img: 'https://app.emtool.eu/public/_lib/img/filter_all_easyer.png',
            title: 'Tutti',
            "id": -1,
            icon: "",
            "color": "black",
            height: 28,
            width: 28,
            aSize: "28px",
        },
        {
            img: 'https://app.emtool.eu/public/_lib/img/icon_ts_open_red.png',
            title: 'Assegnati',
            "id": 1,
            icon: "",
            "color": "",
            height: 25,
            width: 25,
            aSize: "25px",
        },


        {
            img: 'https://app.emtool.eu/public/_lib/img/icon_ts_to_approve_yellow.png',
            title: 'Non Assegnati',
            "id": 2,
            icon: "",
            "color": "",
            height: 25,
            width: 25,
            aSize: "25px",
        },




        ],

        sheetAssegnamento: false,

        textSearch: "",

        dataDa: null,
        showPicker3: false,

        dataA: null,
        showPicker4: false,

        aziende: [],

        search: "",

        sheetAziende: false,

        allStatus: [{
            img: 'keep.png',
            title: 'Refused',
            "id": 1,
            icon: "mdi-account-lock-open",
            "color": "red"
        },
        {
            img: 'hangouts.png',
            title: 'to Approve',
            "id": 2,
            icon: "mdi-account-arrow-right",
            "color": "yellow"
        },
        {
            img: 'inbox.png',
            title: 'Approved',
            "id": 3,
            icon: "mdi-account-lock",
            "color": "green"
        },

        {
            img: 'inbox.png',
            title: 'Open',
            "id": 3,
            icon: "mdi-account-lock-open",
            "color": "orange"
        },

        ],


        allStatusFilter: [

            {
                img: 'https://app.emtool.eu/public/_lib/img/filter_all.png',
                title: 'Tutti',
                "id": -1,
                icon: "mdi-account-lock-open",
                "color": "red",
                width: 12,
                height: 12
            },

            {
                img: 'https://app.emtool.eu/public/_lib/img/usr__NM__ico__NM__red_ball_10.png',
                title: 'Dati non completi e nessun allegato',
                "id": 1,
                icon: "mdi-account-lock-open",
                "color": "red",
                width: 10,
                height: 10

            },

            {
                img: 'https://app.emtool.eu/public/_lib/img/usr__NM__ico__NM__orange_ball_10.png',
                title: 'Dati completi e nessun allegato',
                "id": 2,
                icon: "mdi-account-lock-open",
                "color": "red",
                width: 10,
                height: 10

            },

            {
                img: 'https://app.emtool.eu/public/_lib/img/usr__NM__ico__NM__green_ball_10.png',
                title: 'Completo',
                "id": 3,
                icon: "mdi-account-lock-open",
                "color": "red",
                width: 10,
                height: 10

            },

        ],




        tiles: [{
            img: 'keep.png',
            title: 'Keep'
        }],



        sheetChangeStatus: false,
        sheetStatus: false,

        currItem: { stato: "" },


        showPicker: false,
        profile: {},
        valid: true,
        initials: "",
        namesurname: "",
        iban: "",
        cellulare: "",
        codicefiscale: "",
        codicefiscaleRules: [
            (v) => !!v || "Codice fiscale is required",
            (v) =>
                (v && v.length <= 16) ||
                "Codice fiscale must be less than 16 characters",
        ],
        cellulareRules: [
            (v) => !!v || "Phone number is required",
            (v) =>
                (v && v.length <= 30) || "Phone number must be less than 15 characters",
        ],
        genRules: [(v) => !!v || "Field required"],
        ibanRules: [
            (v) => !!v || "Iban is required",
            (v) => (v && v.length <= 30) || "Iban must be less than 30 characters",
        ],
        email: "",
        emailRules: [
            (v) => !!v || "E-mail is required",
            (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
        ],
        select: null,
        items: ["Item 1", "Item 2", "Item 3", "Item 4"],
        checkbox: false,





    }),

    computed: {

        filteredAziende() {
            return _.orderBy(this.aziende.filter(item => {
                if (!this.search) return this.aziende;
                return (item.fld_name.toLowerCase().includes(this.search.toLowerCase()));
            }), 'headline')


        },

    },

    methods: {

        centerPopupViewFilePdf: function () {



            var windowWidth = $(window).width();
            var windowHeight = $(window).height();


            var divWidth = Math.ceil((90 / 100) * windowWidth);
            var divHeight = Math.ceil((65 / 100) * windowHeight);


            var leftPosition = (windowWidth - divWidth) / 2;
            var topPosition = (windowHeight - divHeight) / 2;

            $('#pViewFilePdf').find('.vm--modal').css({
                'position': 'absolute',
                'left': leftPosition + 'px',
                'top': topPosition + 'px',
                'width': divWidth + 'px',
                'height': divHeight + 'px'
            });


        },


        async loadPdf() {

            pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

            const pdfContainer = document.getElementById('container-view-pdf');
            pdfContainer.innerHTML = '';

            try {
                const pdf = await pdfjsLib.getDocument(this.pdfUrl).promise;
                for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
                    const page = await pdf.getPage(pageNum);
                    const viewport = page.getViewport({ scale: 1.5 });

                    const canvas = document.createElement('canvas');
                    const context = canvas.getContext('2d');
                    canvas.height = viewport.height;
                    canvas.width = viewport.width;

                    const renderContext = {
                        canvasContext: context,
                        viewport: viewport
                    };

                    await page.render(renderContext).promise;

                    pdfContainer.appendChild(canvas);
                }
            } catch (error) {
                console.error('Error loading PDF: ', error);
            }
        },

        btnCancelViewFilePdf: function () {

            this.$modal.hide('popupViewFilePdf');

        },




        // filterNoleggio: function (noleggio) {


        //     console.log("STATUS SEL: ", noleggio);

        //     this.sheetNoleggio = false;

        //     window.curNoleggio = noleggio;

        //     this.hideShowButtons(false);

        //     this.showSpinner = true;
        //     this.$root.$children[0].showProgress = true;

        //     window.table.ajax.reload();


        // },


        // filterFirma: function (firma) {


        //     console.log("STATUS SEL: ", firma);

        //     this.sheetFirma = false;

        //     window.curFirma = firma;

        //     this.hideShowButtons(false);

        //     this.showSpinner = true;
        //     this.$root.$children[0].showProgress = true;

        //     window.table.ajax.reload();


        // },






        openPopupDisassociaRisorsa: async function () {

            var that = this;

            that.dataRiconsegna = null;

            setTimeout(() => {

                $(".contpopupdisassocresource").show();

                that.$modal.show('popupDisassocResource');


            }, 200);


        },


        btnCancelDisassocResource: function () {

            this.$modal.hide('popupDisassocResource');

        },



        btnConfirmDisassocResource: function () {

            var that = this;

            var errore = "";

            if (that.dataRiconsegna == null) {
                errore = "Specificare una data di riconsegna";
            }

            if (errore == "") {

                that.disassociaRisorse();

            }
            else {

                this.$swal({
                    icon: "error",
                    text: errore,
                    showConfirmButton: false,
                    timer: 3000
                });

            }



        },




        btnCancelSendMailNonAss: function () {

            this.$modal.hide("popupMailInvitoNonAss");


        },

        btnConfirmSendMailNonAss: function () {

            var that = this;

            var errore = "";

            var txt_body = tinymce.activeEditor.getContent();

            console.log("MATERIALE: ", that.selMateriale);


            if (that.selMateriale == "") {

                errore = "Specificare la tipologia del materiale";
            }

            if (errore == "") {

                if (txt_body == "") {
                    errore = "Specificare un testo per la mail";
                }

            }

            if (errore == "") {

                console.log("ok");

                this.sendInviteMaterialeNonAssegnato();

            }
            else {

                this.$swal({
                    icon: "error",
                    text: errore,
                    showConfirmButton: false,
                    timer: 2000
                });

            }

        },


        sendInviteMaterialeNonAssegnato: async function () {

            var that = this;

            that.$modal.hide("popupMailInvitoNonAss");

            var v_token = window.$cookies.get("token");

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var ids = "";

            $(".val_status").each(function (index) {

                console.log(index);

                if ($(this).prop("checked")) {

                    if (ids != "") {
                        ids = ids + ",";
                    }
                    ids = ids + $(this).attr("resource-id");
                }

            });

            console.log("IDS SEL:", ids);

            var response = await apicespiti.mandaInvitoMaterialeNonAssegnato(
                ids,
                v_token,
                tinymce.activeEditor.getContent(),
                that.selMateriale
            ).then((res) => {

                that.showSpinner = false;
                that.$root.$children[0].showProgress = false;

                console.log("res from mandaInvitoMaterialeAssegnato", res);

                if (res.data.Result == "OK") {


                    setTimeout(() => {

                        window.table.ajax.reload();



                    }, 200);


                    that.$swal({
                        icon: "success",
                        text: "Invito inviato correttamente",
                        showConfirmButton: false,
                        timer: 2000
                    });




                }
                else {

                    that.$swal({
                        icon: "error",
                        text: res.data.ErrDetails,
                        showConfirmButton: false,
                        timer: 3000
                    });


                }






            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("ERrori", "Non è stato possibile caricare i dati");
                console.log("response", response);

            }

            );



        },




        btnCancelSendMail: function () {

            this.$modal.hide("popupMailInvito");


        },

        btnConfirmSendMail: function () {

            var errore = "";

            var txt_body = tinymce.activeEditor.getContent();

            if (txt_body == "") {
                errore = "Specificare un testo per la mail";
            }

            if (errore == "") {

                console.log("ok");

                this.sendInviteMaterialeAssegnato();

            }
            else {

                this.$swal({
                    icon: "error",
                    text: errore,
                    showConfirmButton: false,
                    timer: 2000
                });

            }

        },

        sendInviteMaterialeAssegnato: async function () {

            var that = this;

            that.$modal.hide("popupMailInvito");

            var v_token = window.$cookies.get("token");

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var ids = "";

            $(".val_status").each(function (index) {

                console.log(index);

                if ($(this).prop("checked")) {

                    if (ids != "") {
                        ids = ids + ",";
                    }
                    ids = ids + $(this).attr("data-id");
                }

            });

            console.log("IDS SEL:", ids);

            var response = await apicespiti.mandaInvitoMaterialeAssegnato(
                ids,
                v_token,
                tinymce.activeEditor.getContent()
            ).then((res) => {

                that.showSpinner = false;
                that.$root.$children[0].showProgress = false;

                console.log("res from mandaInvitoMaterialeAssegnato", res);

                if (res.data.Result == "OK") {


                    setTimeout(() => {

                        window.table.ajax.reload();

                    }, 200);

                    that.$swal({
                        icon: "success",
                        text: "Invito inviato correttamente",
                        showConfirmButton: false,
                        timer: 2000
                    });


                }
                else {

                    that.$swal({
                        icon: "error",
                        text: res.data.ErrDetails,
                        showConfirmButton: false,
                        timer: 3000
                    });


                }






            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("ERrori", "Non è stato possibile caricare i dati");
                console.log("response", response);

            }

            );



        },


        filterAssegnati: function (valore) {


            console.log("STATUS SEL: ", valore);

            this.sheetAssegnamento = false;

            window.curAss = valore;

            this.hideShowButtons(false);

            this.showSpinner = true;
            this.$root.$children[0].showProgress = true;

            window.table.ajax.reload();


        },





        btnResetSearch: function () {

            this.textSearch = "";
            window.curSrcText = "";

            window.curStatus = "-1";
            this.filterStato = "-1";

            window.dataDa = "";
            this.dataDa = "";

            window.dataA = "";
            this.dataA = "";

            window.curNoleggio = "";
            this.filterNoleggio = "";

            window.curFirma = "";
            this.filterFirma = "";

            window.licenzaOffice = "";
            this.filterLicenzaOffice = "";

            window.$cookies.set("sel_filter_azienda_cespiti_admin", 7, "9y");

            $('.selfiltri').attr('src', '/emt/img/emt-filtri-disattivi.png');

            this.$modal.hide('popupSearch');

            this.showSpinner = true;
            this.$root.$children[0].showProgress = true;

            window.table.ajax.reload();
        },


        viewAllegato: async function () {

            var that = this;

            var ids = "";

            $(".val_status").each(function (index) {

                console.log(index);

                if ($(this).prop("checked")) {

                    if (ids != "") {
                        ids = ids + ",";
                    }
                    ids = ids + $(this).attr("data-id");
                }

            });

            console.log("IDS SEL:", ids);


            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apicespiti.downAttach(
                ids
            ).then((res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from downAttach", res);

                setTimeout(() => {


                    $(".contpopupviewfilepdf").show();

                    that.$modal.show('popupViewFilePdf');

                    that.pdfUrl = res.data.UrlVal;

                    setTimeout(() => {


                        that.loadPdf();

                        that.centerPopupViewFilePdf();


                    }, 200);



                }, 100);







            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile eliminare i dati");
                console.log("response", response);

            }

            );

        },





        downAllegato: async function () {

            var that = this;

            var ids = "";

            $(".val_status").each(function (index) {

                console.log(index);

                if ($(this).prop("checked")) {

                    if (ids != "") {
                        ids = ids + ",";
                    }
                    ids = ids + $(this).attr("data-id");
                }

            });

            console.log("IDS SEL:", ids);


            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apicespiti.downAttach(
                ids
            ).then((res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from downAttach", res);


                setTimeout(() => {

                    window.table.ajax.reload();

                    var file_path = res.data.UrlVal;
                    var a = document.createElement('A');
                    a.href = file_path;
                    a.target = "_blank";
                    a.download = file_path.substr(file_path.lastIndexOf('/') + 1);
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);


                }, 200);








            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile eliminare i dati");
                console.log("response", response);

            }

            );

        },


        btnCancelSearch: function () {

            this.$modal.hide('popupSearch');

        },


        btnConfirmSearch: function () {

            console.log("ok");

            window.curSrcText = this.textSearch;



            window.curStatus = this.filterStato;

            window.dataDa = this.dataDa;

            window.dataA = this.dataA;

            window.curNoleggio = this.filterNoleggio;

            window.curFirma = this.filterFirma;

            window.licenzaOffice = this.filterLicenzaOffice;


            window.$cookies.set("sel_filter_azienda_cespiti_admin", this.filterAzienda, "9y");


            $('.selfiltri').attr('src', '/emt/img/emt-filtri-attivi.png');


            if ((window.curSrcText == "") && (window.curStatus == "") && (window.dataDa == "") && (window.dataA == "") && (window.curNoleggio == "") && (window.curFirma == "") && (window.licenzaOffice == "")) {


                $('.selfiltri').attr('src', '/emt/img/emt-filtri-disattivi.png');
            }


            this.$modal.hide('popupSearch');

            this.showSpinner = true;
            this.$root.$children[0].showProgress = true;

            window.table.ajax.reload();

        },

        manageClickAziende: async function (azienda) {

            console.log("AZI SEL: ", azienda);

            this.sheetAziende = false;

            window.curCompany = azienda.companyid;

            window.$cookies.set("sel_filter_azienda_cespiti_admin", azienda.companyid, "9y");


            this.hideShowButtons(false);

            this.showSpinner = true;
            this.$root.$children[0].showProgress = true;

            window.table.ajax.reload();


        },


        // manageClickAziende: async function (azienda) {

        //     console.log("AZI SEL: ", azienda);

        //     this.sheetAziende = false;

        //     this.filterAzienda = azienda.companyid;


        // },



        sendInvite: async function () {

            tinymce.remove();

            var that = this;

            var ids = "";

            var v_row = null;


            $(".val_status").each(function (index) {

                console.log(index);

                if ($(this).prop("checked")) {

                    v_row = $(this);


                    if (ids != "") {
                        ids = ids + ",";
                    }
                    ids = ids + $(this).attr("data-id");
                }

            });

            var v_data_row = window.table.row(v_row.parent().parent()).data();

            console.log("DATA ROW: ", v_data_row);

            if (ids > 0) // risorsa con materiale associato
            {

                var txtPrevMail = "Cordiale <b>" + v_data_row.surname + " " + v_data_row.name + "</b>";

                txtPrevMail = txtPrevMail + "<br><br>aggiorni le informazioni relative al materiale in suo possesso";

                txtPrevMail = txtPrevMail + "<br><br>Per farlo premere sul pulsante sottostante";

                txtPrevMail = txtPrevMail + "<br><br>#LinkPulsante#";

                if (window.curCompany == 7) {

                    txtPrevMail = txtPrevMail + "<br><br>Cordiali Saluti<br>LC-Service srl";

                }

                if (window.curCompany == 8) {

                    txtPrevMail = txtPrevMail + "<br><br>Cordiali Saluti<br>Ariall srl";

                }


                $(".contpopupmailinvito").show();

                that.$modal.show('popupMailInvito');


                setTimeout(() => {

                    tinymce.init({
                        selector: '#sec_body',  // change this value according to your HTML

                        plugin: 'a_tinymce_plugin',
                        height: "370",
                        mode: "textareas",
                        entity_encoding: "raw",
                        add_unload_trigger: false,
                        remove_linebreaks: false,
                        apply_source_formatting: false,
                        force_br_newlines: true,
                        force_p_newlines: false,
                        forced_root_block: '', // Needed for 3.x

                        a_plugin_option: true,
                        a_configuration_option: 400

                    });

                    setTimeout(() => {
                        tinymce.activeEditor.setContent(txtPrevMail);

                    }, 700);

                }, 500);


            }

            if (ids == 0) // risorsa senza materiale associato
            {

                var txtPrevMail2 = "Cordiale <b>" + v_data_row.surname + " " + v_data_row.name + "</b>";

                txtPrevMail2 = txtPrevMail2 + "<br><br>aggiorni le informazioni relative al materiale in suo possesso";

                txtPrevMail2 = txtPrevMail2 + "<br><br>Per farlo premere sul pulsante sottostante";

                txtPrevMail2 = txtPrevMail2 + "<br><br>#LinkPulsante#";

                txtPrevMail2 = txtPrevMail2 + "<br><br>Cordiali Saluti<br>LC-Service srl / Ariall srl";

                $(".contpopupmailinvitononass").show();

                that.$modal.show('popupMailInvitoNonAss');


                setTimeout(() => {

                    tinymce.init({
                        selector: '#sec_body',  // change this value according to your HTML

                        plugin: 'a_tinymce_plugin',
                        height: "370",
                        mode: "textareas",
                        entity_encoding: "raw",
                        add_unload_trigger: false,
                        remove_linebreaks: false,
                        apply_source_formatting: false,
                        force_br_newlines: true,
                        force_p_newlines: false,
                        forced_root_block: '', // Needed for 3.x

                        a_plugin_option: true,
                        a_configuration_option: 400

                    });

                    setTimeout(() => {
                        tinymce.activeEditor.setContent(txtPrevMail2);

                    }, 700);

                }, 500);


            }

        },


        sendInviteOld: async function () {

            var that = this;

            var v_token = window.$cookies.get("token");

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var ids = "";

            $(".val_status").each(function (index) {

                console.log(index);

                if ($(this).prop("checked")) {

                    if (ids != "") {
                        ids = ids + ",";
                    }
                    ids = ids + $(this).attr("data-id");
                }

            });

            console.log("IDS SEL:", ids);

            var response = await apicespiti.mandaInvito(
                ids,
                v_token
            ).then((res) => {

                that.showSpinner = false;
                that.$root.$children[0].showProgress = false;

                console.log("res from mandaInvito", res);

                that.$swal({
                    icon: "success",
                    text: "Inviti inviati correttamente",
                    showConfirmButton: false,
                    timer: 2000
                });



            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("ERrori", "Non è stato possibile caricare i dati");
                console.log("response", response);

            }

            );

        },




        syncAziende: function () {

            var that = this;

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            setTimeout(() => {

                that.$root.$children[0].showProgress = false;

                that.aziende = JSON.parse(window.$cookies.get("companyUser"));

            }, 300);


        },

        changeStatus: async function (status) {

            console.log(status);

            this.sheetStatus = false;

            this.showSpinner = true;
            this.$root.$children[0].showProgress = true;

            window.curStatus = status;

            this.hideShowButtons(false);

            window.table.ajax.reload();


        },


        disassociaRisorse: async function () {

            var that = this;

            var v_token = window.$cookies.get("token");

            that.$swal
                .fire({
                    title: "Elimina",
                    html: "Vuoi disassociare le risorse dai loro cespiti ?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "<img title='Conferma' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_confirm3_emt.png' />",
                    cancelButtonText: "<img title='Annulla' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_cancel3_emt.png' />",
                    customClass: {
                        cancelButton: 'order-1',
                        confirmButton: 'order-2',
                    }

                })
                .then(async function (result) {

                    if (result.value == true) {

                        var ids = "";

                        $(".val_status").each(function (index) {

                            console.log(index);

                            if ($(this).prop("checked")) {

                                if (ids != "") {
                                    ids = ids + ",";
                                }
                                ids = ids + $(this).attr("data-id");
                            }

                        });

                        console.log("IDS SEL:", ids);



                        that.showSpinner = true;
                        that.$root.$children[0].showProgress = true;

                        var response = await apicespiti.disassociaRisorse(
                            ids,
                            v_token,
                            that.dataRiconsegna
                        ).then((res) => {

                            that.$root.$children[0].showProgress = false;
                            console.log("res from deleteCespiti", res);


                            if (res.data.Result == "OK") {

                                that.$modal.hide('popupDisassocResource');

                                that.$swal({
                                    icon: "success",
                                    text: "Aggiornamento effettuato correttamente",
                                    showConfirmButton: false,
                                    timer: 2000
                                });

                                setTimeout(() => {

                                    that.dialogMsg = false;
                                    that.setupButtons();



                                    window.table.ajax.reload();

                                    that.hideShowButtons(false);


                                }, 200);
                            }
                            else {


                                that.$swal({
                                    icon: "error",
                                    text: res.data.ErrDetails,
                                    showConfirmButton: false,
                                    timer: 3000
                                });

                            }




                        }).catch(err => {
                            that.$root.$children[0].showProgress = false;
                            console.log(err);
                            var msg = err.response.data.Error;

                            that.$swal({
                                icon: "error",
                                text: msg,
                                showConfirmButton: false,
                                timer: 8000
                            });
                            console.log("Errori", "Non è stato possibile eliminare i dati");
                            console.log("response", response);

                        }

                        );

                    }

                });

        },







        deleteRow: async function () {

            var that = this;

            var v_token = window.$cookies.get("token");

            that.$swal
                .fire({
                    title: "Elimina",
                    html: "Vuoi eliminare l'elemento selezionato ?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "<img title='Conferma' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_confirm3_emt.png' />",
                    cancelButtonText: "<img title='Annulla' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_cancel3_emt.png' />",
                    customClass: {
                        cancelButton: 'order-1',
                        confirmButton: 'order-2',
                    }

                })
                .then(async function (result) {

                    if (result.value == true) {

                        var ids = "";

                        $(".val_status").each(function (index) {

                            console.log(index);

                            if ($(this).prop("checked")) {

                                if (ids != "") {
                                    ids = ids + ",";
                                }
                                ids = ids + $(this).attr("data-id");
                            }

                        });

                        console.log("IDS SEL:", ids);



                        that.showSpinner = true;
                        that.$root.$children[0].showProgress = true;

                        var response = await apicespiti.deleteCespiti(
                            ids,
                            v_token
                        ).then((res) => {

                            that.$root.$children[0].showProgress = false;
                            console.log("res from deleteCespiti", res);

                            that.$swal({
                                icon: "success",
                                text: "Dati eliminati correttamente",
                                showConfirmButton: false,
                                timer: 2000
                            });

                            setTimeout(() => {

                                that.dialogMsg = false;
                                that.setupButtons();



                                window.table.ajax.reload();

                                that.hideShowButtons(false);


                            }, 200);

                        }).catch(err => {
                            that.$root.$children[0].showProgress = false;
                            console.log(err);
                            var msg = err.response.data.Error;

                            that.$swal({
                                icon: "error",
                                text: msg,
                                showConfirmButton: false,
                                timer: 8000
                            });
                            console.log("Errori", "Non è stato possibile eliminare i dati");
                            console.log("response", response);

                        }

                        );

                    }

                });

        },



        delMsg: function async() {
            var token = window.$cookies.get("token");
            var that = this;

            this.$swal
                .fire({
                    title: "Sei sicuro?",
                    html: "Vuoi eliminare gli elementi selezionati ? ",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "<img title='Conferma' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_confirm3_emt.png' />",
                    cancelButtonText: "<img title='Annulla' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_cancel3_emt.png' />",
                    customClass: {
                        cancelButton: 'order-1',
                        confirmButton: 'order-2',
                    }

                })
                .then(async function (result) {

                    if (result.value == true) {

                        var ids = "";

                        $(".val_status").each(function (index) {

                            console.log(index);

                            if ($(this).prop("checked")) {

                                if (ids != "") {
                                    ids = ids + ",";
                                }
                                ids = ids + $(this).attr("data-id");
                            }

                        });

                        console.log("IDS SEL:", ids);


                        //start request
                        var response;

                        try {

                            //  that.showSpinner = true;
                            that.$root.$children[0].showProgress = true;

                            response = await that.$api.deleteMultiFerie(
                                ids,
                                token

                            ).then((res) => {

                                that.$root.$children[0].showProgress = false;
                                console.log("res from deleteMultiFerie", res);

                                that.$swal({
                                    icon: "success",
                                    text: "La tua richiesta è stata rimossa correttamente",
                                    showConfirmButton: false,
                                    timer: 3000
                                });

                                that.hideShowButtons(false);

                                window.table.ajax.reload();

                            }).catch(err => {
                                that.$root.$children[0].showProgress = false;
                                console.log(err);
                                var msg = err.response.data.Error;

                                that.$swal({
                                    icon: "error",
                                    text: msg,
                                    showConfirmButton: false,
                                    timer: 8000
                                });
                                console.log("ERrori", "Non è stato possibile eliminare questa richiesta");
                                console.log("response", response);

                            }

                            );


                        } catch (error) {
                            that.$root.$children[0].showProgress = false;
                            console.log(error);

                        }
                        console.log(response);


                    }
                });



        },



        changeStatusAdmin: async function (status) {

            //  this.currFilterStatus = status;

            console.log(status);


            //START
            var token = window.$cookies.get("token");

            /*   var username = window.$cookies.get("username");
              var token_system = window.$cookies.get("token_system"); */
            //var API_URL = "https://services.ebadge.it/public/api/sendReqHoliday";

            //var API_URL = "https://app.emtool.eu/api/acceptRejectHolidaysPermits";

            var API_URL = this.getUrlDomainApi("acceptRejectMultiHolidaysPermits");

            //var id_richiesta = window.id_par_sel;

            var ids = "";

            $(".val_status").each(function (index) {

                console.log(index);

                if ($(this).prop("checked")) {

                    if (ids != "") {
                        ids = ids + ",";
                    }
                    ids = ids + $(this).attr("data-id");
                }

            });

            console.log("IDS SEL:", ids);


            var operation = "";
            if (status == "Refused") operation = 'reject';
            if (status == "to Approve") operation = 'to Approve';
            if (status == "Approved") operation = 'accept';
            if (status == "Open") operation = 'open';

            console.log("STATUS: ", status);
            console.log("TOKEN: ", token);
            console.log("API_URL: ", API_URL);
            console.log("OPERATION: ", operation);
            console.log("ID_RICHIESTA: ", ids);

            var that = this;
            that.$root.$children[0].showProgress = true;

            /* eslint-disable no-unreachable */
            /*    return; */
            $.ajax({
                type: "POST",
                url: API_URL,
                data: {
                    "v_user": token,
                    'id_richiesta': ids,
                    'operation': operation,
                },
                success: function (resultData) {

                    that.$root.$children[0].showProgress = false;

                    console.log("resultData", resultData, that);

                    that.$swal({
                        icon: "success",
                        text: "La richiesta è stata inviata correttamente",
                        showConfirmButton: false,
                        timer: 2000
                    });
                    that.sheetChangeStatus = false;

                    that.hideShowButtons(false);

                    window.table.ajax.reload();

                },
                error: function (errorData) {

                    that.sheetChangeStatus = false;

                    console.log(errorData);
                    var msg = errorData.responseJSON.Error;

                    that.$swal({
                        icon: "error",
                        text: msg,
                        showConfirmButton: false,
                        timer: 3000
                    });
                    that.showSpinner = false;

                }
            });
            //END

        },



        sendInApprovation: function () {


            var that = this;
            var token = window.$cookies.get("token");

            var API_URL = this.getUrlDomain("sendMultiRequestHolidaysPermits");

            //var id_richiesta = window.id_par_sel;

            var ids = "";

            $(".val_status").each(function (index) {

                console.log(index);

                if ($(this).prop("checked")) {

                    if (ids != "") {
                        ids = ids + ",";
                    }
                    ids = ids + $(this).attr("data-id");
                }

            });

            console.log("IDS SEL:", ids);




            console.log("TOKEN: ", token);
            console.log("API_URL: ", API_URL);
            console.log("id_richiesta: ", ids);

            that.$root.$children[0].showProgress = true;

            $.ajax({
                type: "GET",
                url: API_URL,
                data: {
                    "v_user": token,
                    'id_richiesta': ids,

                },
                success: function (resultData) {
                    that.$root.$children[0].showProgress = false;
                    console.log("resultData", resultData, that);

                    that.$swal({
                        icon: "success",
                        text: "La richiesta è stata inviata correttamente",
                        showConfirmButton: false,
                        timer: 2000
                    });

                    that.hideShowButtons(false);

                    window.table.ajax.reload();


                },
                error: function (errorData) {
                    console.log(errorData);
                    var msg = errorData.responseJSON.Error;

                    that.$swal({
                        icon: "error",
                        text: msg,
                        showConfirmButton: false,
                        timer: 3000
                    });
                    that.$root.$children[0].showProgress = false;

                }
            });


        },


        getUrlDomain: function (nome_metodo) {

            let result = "";

            if (location.hostname == "localhost") {
                result = location.protocol + "//emtool.local/";
            }

            if (location.hostname != "localhost") {

                result = location.protocol + "//" + location.hostname + "/";

            }

            return result + nome_metodo;

        },

        getUrlDomainApi: function (nome_metodo) {

            let result = "";

            if (location.hostname == "localhost") {
                result = location.protocol + "//emtool.local/public/api/";
            }

            if (location.hostname != "localhost") {

                result = location.protocol + "//" + location.hostname + "/api/";

            }

            return result + nome_metodo;

        },

        setupGrid: function () {

            var pointerVue = this;

            var a = window.$cookies.get("a");
            var b = window.$cookies.get("b");



            var filtri = `<img src='/emt/img/filtro-stato-emt.png' style='border:0!important;' class='selstato' title='Stato' /><img src='/emt/img/calendar-emt.png' style='border:0!important;' class='seldata' title='Seleziona Data' />`;

            if (a == 'Y' || a == 'S' || b == 'Y' || b == 'S') {



                filtri = "<img src='/emt/img/refresh-emt.png' style='border:0!important;' class='selaggiorna' title='Aggiorna' /><img src='/emt/img/aziende-emt.png' style='border:0!important;' class='selazienda' title='Aziende' /><img src='/emt/img/emt-filtri-disattivi.png' style='border:0!important;' class='selfiltri' title='Filtri' />";


            }



            $(document).ready(function () {

                var v_token = window.$cookies.get("token");


                window.columns = [

                    {
                        data: 'sel_row',
                        orderable: false,
                        searchable: false,
                        name: '',
                        width: '1%',
                    },

                    {
                        data: 'DT_RowIndex',
                        orderable: true,
                        searchable: false,
                        name: '',
                        width: '1%',
                    },

                    {
                        data: 'surname',
                        orderable: true,
                        name: 'surname',
                        width: '4%'
                    },

                    {
                        data: 'name',
                        orderable: true,
                        name: 'name',
                        width: '4%'
                    },

                    {
                        data: 'desc_type',
                        orderable: true,
                        name: 'desc_type',
                        width: '4%'
                    },

                    {
                        data: 'description',
                        orderable: true,
                        name: 'description',
                        width: '4%'
                    },

                    {
                        data: 'licenza_office',
                        orderable: true,
                        name: 'licenza_office',
                        width: '4%'
                    },

                    {
                        data: 'desc_sede',
                        orderable: true,
                        name: 'desc_sede',
                        width: '4%'
                    },

                    {
                        data: 'noleggio',
                        orderable: false,
                        name: 'noleggio',
                        width: '1%'
                    },

                    {
                        data: 'assignmentdate',
                        orderable: true,
                        name: 'assignmentdate',
                        width: '4%'
                    },

                    {
                        data: 'redelivery',
                        orderable: true,
                        name: 'redelivery',
                        width: '4%'
                    },

                    {
                        data: 'status',
                        orderable: false,
                        name: 'status',
                        width: '4%'
                    },

                    {
                        data: 'firmato',
                        orderable: false,
                        name: 'firmato',
                        width: '1%'
                    },

                    {
                        data: 'allegato',
                        orderable: false,
                        name: 'allegato',
                        width: '4%'
                    },

                    {
                        data: 'data_invito',
                        orderable: true,
                        name: 'data_invito',
                        width: '4%'
                    },




                ];


                $(".spin").show();



                window.table = $('#myTable').DataTable({
                    // dom: "<'row'<'col-sm-12 col-md-6'l><'col-sm-12 col-md-6'f>>" +
                    //     "<'rows colcontTable'<'col-sm-12 'tr>>" +
                    //     "<'row'<'col-sm-12 col-ok  col-md-12'i><'col-sm-12 col-ok-2  col-md-12'p>>",
                    "pagingType": "simple",
                    responsive: true,
                    "pageLength": window.perpage,

                    processing: false,
                    paging: false,
                    serverSide: false,

                    ajax: {
                        url: pointerVue.getUrlDomain("goGetCespitiEmt") + '?username=' + v_token,
                        data: function (valori) {

                            console.log("VALORI:", valori);

                            try {
                                window.table.clear().draw();

                            } catch (error) {
                                console.log(error);
                            }

                            window.start = window.perpage;

                            valori.start = 0;
                            valori.length = window.perpage;

                            valori.curCompany = window.curCompany;
                            valori.curStatus = window.curStatus;

                            valori.dataDa = window.dataDa;
                            valori.dataA = window.dataA;

                            valori.curSrcText = window.curSrcText;

                            valori.curAss = window.curAss;

                            valori.curNoleggio = window.curNoleggio;

                            valori.curFirma = window.curFirma;

                            valori.licenzaOffice = window.licenzaOffice;


                            window.valori = valori;
                            return valori;

                        }

                    },

                    language: {

                        lengthMenu: `<label>Mostra<select name="myTable_length" aria-controls="myTable" class="custom-select custom-select-sm form-control-sm"><option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option><option value="-1">Tutti</option></select>Inserimenti</label>`,

                        paginate: {
                            next: "<img style='height:15px;border:none' src='https://app.emtool.eu/_lib/img/next2.png'>",
                            previous: "<img style='height:15px;border:none' src='https://app.emtool.eu/_lib/img/previous2.png'>"
                        },

                        "sSearch": " ",
                        processing: '<svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66"><circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle></svg>'
                    },
                    "info": "",
                    "fnDrawCallback": function (oSettings) {

                        console.log(oSettings);

                        $("body").tooltip({
                            selector: '[data-toggle="tooltip"]'
                        });
                    },

                    columns: window.columns,

                    "initComplete": function (settings) {

                        console.log(settings);

                        $("#myTable_wrapper").show();
                        $(".spin").hide();

                    },
                    "drawCallback": function (settings) {

                        console.log(settings);

                        $(".spin").hide();

                        setTimeout(function () {

                            pointerVue.showSpinner = false;
                            pointerVue.$root.$children[0].showProgress = false;

                        }, 700);






                        var elements = $('.datetimeBook');
                        elements.each(function () {

                            var id = $(this).data("id");
                            (this).pickerOptions = {
                                buttons: [{
                                    text: 'Cancel',
                                    role: 'cancel',
                                    cssClass: 'switch-btn-cancel',
                                },
                                {
                                    text: 'Done',
                                    cssClass: 'switch-btn-done',
                                    handler: columns => {
                                        console.log("ore minuti id", columns.hour.text, columns.minute.text, id);
                                        var valore = columns.hour.text + ":" + columns.minute.text;

                                        console.log(valore);

                                        $.ajax({
                                            url: pointerVue.getUrlDomain("updateHour"),
                                            data: {
                                                "id": id,
                                                "hour": valore,
                                                "v_user": "ZmFnb3N0b25p"
                                            },
                                            success: function () { }
                                        });

                                    }
                                },
                                ],
                            };
                        });

                        setTimeout(function () {

                            //   $("#myTable_filter").width($("#myTable").width());

                        }, 300);

                        var selects = $('.selectstatus');
                        selects.each(function () {
                            var id = $(this).data("id");

                            console.log("ciaone", $(this).data("id"));

                            $(this).on("ionChange", function (opt) {

                                console.log(opt);

                                $(".spin").show();
                                $.ajax({
                                    url: pointerVue.getUrlDomain("updateStatus"),
                                    data: {
                                        "id": id,
                                        "hour": this.value,
                                        "v_user": "ZmFnb3N0b25p"
                                    },
                                    success: function () {
                                        window.table._fnDraw();
                                    }
                                });

                            });

                        });

                        $(".downloadspinner").hide();

                        setTimeout(() => {


                            $('#myTable tbody tr td:nth-child(2)').attr('style', 'padding-right:31px !important;');

                        }, 500);


                        $('.dt-type-numeric').removeClass('dt-type-numeric');
                        $('.dt-type-date').removeClass('dt-type-date');



                    }

                });




                //Events
                //START SETUP
                function throttle(f, delay) {
                    var timer = null;
                    return function () {
                        var context = this,
                            args = arguments;
                        clearTimeout(timer);
                        timer = window.setTimeout(function () {
                            f.apply(context, args);
                        },
                            delay || 500);
                    };
                }
                window.loading = 0;
                $("div.dataTables_filter input").unbind();
                $('div.dataTables_filter input').keyup(throttle(function () {
                    window.table.ajax.reload();

                }));
                $('#myTable_wrapper').on('scroll', function () {
                    if ($(this).scrollTop() + $(this).innerHeight() + 50 >= $(this)[0].scrollHeight) {
                        if (window.loading == 0) {
                            $(".spin").show();

                            setTimeout(() => {

                                $(".spin").hide();
                                window.loading = 0;

                            }, 500);


                        }
                        window.loading = 1;
                    }
                });
                //END

                var search = $(".dataTables_length").clone(true);
                search.attr("id", "final_search");
                $(".table_paginate").prepend(search);

                $("#myTable_wrapper .dt-layout-row").first().find("div").remove();

                $("#myTable_wrapper .dt-layout-end").remove();


                $("#myTable_wrapper .dt-layout-row").first().prepend(`
                <div class="cont_buttons">

                    <div style='display:flex;justify-content: center;
    justify-items: center;
    align-items: center;'><div><input type='checkbox' style='min-width:13px!important' id='chkAssegnati' checked /></div><div style='margin-left:5px;font-weight:bold'>Assegnati</div><div style='margin-left:5px'>/</div><div style='margin-left:5px' class='goToNonAssegnati'><input type='checkbox' style='min-width:13px!important' id='chkNonAssegnati' /></div><div style='margin-left:5px;font-weight:bold' class='goToNonAssegnati' >Non Assegnati</div></div>
                       ` + filtri + `

                </div>
               

            `);



                $(".goToNonAssegnati").on("click", function (opt) {
                    console.log(opt);

                    router.push({
                        path: "/cespitiNonAssegnatiAdmin"
                    });

                });


                $('body').on('click', '#cont_filtercompany', function () {

                    console.log(("EVENTO CLICK SELAZIENDA"));

                    pointerVue.sheetAziende = true;

                });






                $(".selassegnamento").on("click", function (opt) {

                    console.log(opt);

                    pointerVue.sheetAssegnamento = true;


                });

                $(".selfiltri").on("click", function (opt) {
                    console.log(opt);



                    $(".contpopupsearch").show();

                    pointerVue.$modal.show('popupSearch');

                });


                $(".selricerca").on("click", function (opt) {
                    console.log(opt);

                    pointerVue.textSearch = "";

                    $(".contpopupsearch").show();

                    pointerVue.$modal.show('popupSearch');

                });

                $('body').on('click', '.paginate_button', function () {
                    $(".spin").show();

                });

                $('body').on('click', '.refreshButton', function () {

                    $(".spin").show();
                    window.table._fnDraw();

                });


                $(".selectstatusall").on("ionChange", function (opt) {
                    console.log(opt);
                    $(".spin").show();
                    window.curStatus = this.value;



                    window.table.ajax.reload();

                });


                $('body').on('click', '.cont_cespiti_admin_ok tr', function () {

                    var row_data = window.table.row(this).data();

                    if (row_data != null) {


                        var last_id_sel = $("tr.active-row").find(".id_row").attr("data-id");

                        var id_sel = $(this).find(".id_row").attr("data-id");

                        var set_cls_active = 0;

                        if (last_id_sel == "undefined") {
                            set_cls_active = 1;
                        } else {
                            if (last_id_sel != id_sel) {
                                set_cls_active = 1;
                            }
                        }

                        console.log("ROM IS ACTIVE: ", set_cls_active);



                        console.log("THIS: ", this);

                        var hasClassActive = $(this).hasClass("active-row");

                        if (hasClassActive) {

                            console.log("ACTIVE-ROW");

                            $(this).find(".val_status").prop("checked", false);

                            $(this).removeClass("active-row");

                        }

                        if (!hasClassActive) {

                            console.log("NOT ACTIVE-ROW");

                            $(this).find(".val_status").prop("checked", true);

                            $(this).addClass("active-row");



                        }

                        window.id_par_sel = $("tr.active-row").find(".id_row").attr("data-id");

                        if (window.id_par_sel == undefined) {
                            window.id_par_sel = id_sel;
                        }

                        console.log("ID SELECTED: ", window.id_par_sel);

                        pointerVue.hideShowButtonsSelRow();


                    }



                });


                window.parentiAddedEvents = true;

            });

        },


        hideShowButtonsSelRow: function () {

            var tot = 0;
            var tot_open_status = 0;
            var v_id = 0;
            var has_allegato = 0;

            $(".val_status").each(function (index) {

                console.log(index);

                if ($(this).prop("checked")) {

                    tot = tot + 1;


                    var val_status_id = $(this).attr("status-id");

                    v_id = $(this).attr("data-id");
                    has_allegato = $(this).attr("has-allegato");

                    if (val_status_id == "Open") // stato aperto
                    {

                        tot_open_status = tot_open_status + 1;

                    }



                }

            });

            console.log("TOT SEL: ", tot);
            console.log("TOT SEL OPEN STATUS: ", tot_open_status);


            setTimeout(() => {

                var pulsantis = [];


                if (tot == 1) {



                    if (v_id != 0) {

                        pulsantis.push(

                            {
                                text: "Edit",
                                icon: "mdi-home-circle",
                                image: "https://app.emtool.eu/public/_lib/img/icon_edit_emt.png",
                                link: "/info",
                                id: "btn_edit",
                                disabled: false,
                                width: 30
                            }



                        );

                    }




                }


                if (tot == 1) {

                    if (v_id != 0) {


                        pulsantis.push({
                            text: "Edit",
                            icon: "mdi-home-circle",
                            image: "https://app.emtool.eu/public/_lib/img/download_emt.png",
                            link: "/info",
                            id: "btn_download",
                            disabled: false,
                            title: "Scarica Allegato",
                            width: 25
                        });


                        if (has_allegato == 1) {

                            pulsantis.push({
                                text: "Edit",
                                icon: "mdi-home-circle",
                                image: "https://app.emtool.eu/public/_lib/img/view_emt.png",
                                link: "/info",
                                id: "btn_view",
                                disabled: false,
                                title: "Vedi Allegato",
                                width: 35
                            });



                        }


                    }



                }


                if (tot == 1) {

                    pulsantis.push(

                        {
                            text: "",
                            icon: "mdi-delete",
                            image: "https://app.emtool.eu/public/_lib/img/invio-emt.png",
                            link: "/delete",
                            id: "btn_send_invite",
                            disabled: false,
                            title: "Manda Invito",
                            width: 30
                        }


                    );


                    pulsantis.push(

                        {
                            text: "",
                            icon: "mdi-delete",
                            image: this.getUrlDomain("public/_lib/img/risorse2_disassocia.png"),
                            link: "/delete",
                            id: "btn_disassocia",
                            disabled: false,
                            title: "Disassocia Risorsa",
                            width: 30
                        }




                    );


                }




                this.$root.$children[0].bnavbuttons = pulsantis;

            }, 100);






        },






        hideShowButtons: async function (v_enable) {

            console.log(v_enable);

            setTimeout(() => {

                // var a = window.$cookies.get("a");
                // var b = window.$cookies.get("b");

                var pulsantis = [];

                // if (v_enable == false) {
                //     pulsantis.push(

                //         {
                //             text: "Add",
                //             icon: "mdi-home-circle",
                //             image: "https://app.emtool.eu/public/_lib/img/xbox-cross-emt.png",
                //             link: "/settings",
                //             id: "btn_add",
                //             disabled: false,
                //             width: 30
                //         }



                //     );





                // }

                // if (v_enable == true) {

                //     if (a == 'N' && b == 'N') { // dipendente

                //         if (window.id_status == "Open") {

                //             pulsantis.push({
                //                 text: "sendinapprovation",
                //                 icon: "mdi-send-clock-outline",
                //                 link: "/delete",
                //                 id: "btn_send_approvation",
                //                 disabled: false,
                //             });

                //         }

                //     }

                //     if (a == 'Y' || a == 'S' || b == 'S' || b == 'Y') {

                //         pulsantis.push(

                //             {
                //                 text: "",
                //                 icon: "mdi-send-clock-outline",
                //                 link: "/btn_changestatusadmin",
                //                 id: "btn_changestatusadmin",
                //                 disabled: false,
                //                 image: "https://app.emtool.eu/public/_lib/img/cambio-stato-emt.png",
                //                 title: "Aggiorna Stato",
                //                 width: 30

                //             }

                //         );

                //     }

                //     pulsantis.push(

                //         {
                //             text: "",
                //             icon: "mdi-delete",
                //             image: "https://app.emtool.eu/public/_lib/img/icon_delete_emt.png",
                //             link: "/delete",
                //             id: "btn_delete",
                //             disabled: false,
                //             title: "Elimina",
                //             width: 30
                //         }



                //     );



                // }

                this.$root.$children[0].bnavbuttons = pulsantis;

            }, 100);

        },

        setupButtonsGrid: async function () {
            setTimeout(() => {
                // console.log ("here we go" , this.$root.$children[0].drawer ) ;
                //window.App.$children[0].setToolbar();
                //   this.$root.$children[0].setToolbar();

                var pulsantis = [

                    {
                        text: "Add",
                        icon: "mdi-home-circle",
                        image: "https://app.emtool.eu/public/_lib/img/xbox-cross-emt.png",
                        link: "/settings",
                        id: "btn_add",
                        disabled: false,
                        width: 30
                    },

                    {
                        text: "Edit",
                        icon: "mdi-home-circle",
                        image: "https://app.emtool.eu/public/_lib/img/icon_edit_emt.png",
                        link: "/info",
                        id: "btn_edit",
                        disabled: false,
                        width: 30
                    },

                    {
                        text: "Delete",
                        icon: "mdi-home-circle",
                        image: "https://app.emtool.eu/public/_lib/img/icon_delete_emt.png",
                        link: "/info",
                        id: "btn_delete",
                        disabled: false,
                        width: 30
                    },

                    {
                        text: "Dashboard",
                        icon: "mdi-home-circle",
                        link: "/dash",
                        id: "btn_exit",
                        disabled: false,
                    },

                ];
                //window.App.$children[0].bnavbuttons = pulsantis;
                this.$root.$children[0].bnavbuttons = pulsantis;

                setTimeout(() => {

                }, 100);

            }, 100);
        },

        setupButtons: async function () {
            setTimeout(() => {
                // console.log ("here we go" , this.$root.$children[0].drawer ) ;
                //window.App.$children[0].setToolbar();
                //   this.$root.$children[0].setToolbar();

                var pulsantis = [

                    {
                        text: "Dashboard",
                        icon: "mdi-home-circle",
                        link: "/qrconfirm",
                        id: "btn_qrcode",
                        image: "https://app.smart-book.it/public/smartbook/ICON_3.png",
                        disabled: false,
                    },

                    {
                        text: "Settings",
                        icon: "mdi-home-circle",
                        image: "https://app.smart-book.it/public/_lib/img/icons8-settings-64.png",
                        class: "inverted",
                        link: "/settings",
                        id: "btn_settings",
                        disabled: false,
                    },

                    {
                        text: "Info",
                        icon: "mdi-home-circle",
                        image: "https://app.smart-book.it/public/_lib/img/icons8-informazioni-482.png",
                        class: "inverted",
                        link: "/info",
                        id: "btn_info",
                        disabled: false,
                    },

                    {
                        text: "Pdf",
                        icon: "mdi-home-circle",
                        image: "https://app.smart-book.it/public/_lib/img/sb-export-pdf-50.png",
                        class: "inverted",
                        link: "/pdf",
                        id: "btn_pdf",
                        disabled: false,
                    },

                ];

                //window.App.$children[0].bnavbuttons = pulsantis;
                this.$root.$children[0].bnavbuttons = pulsantis;

                setTimeout(() => {

                }, 100);

            }, 100);
        },

        syncProfile: async function () {
            /*  var token = window.$cookies.get("token");
            var system = window.$cookies.get("system"); */

            //  this.data.days = response.data ;
        },

        btn_add_tms_click() {
            console.log(1);
        },
        /*          onClick() {
      console.log('a phone number was clicked');
    }
    ,
    */
        reply(par) {
            console.log(par);
        },

        reset() {
            this.$refs.form.reset();
        },
        resetValidation() {
            this.$refs.form.resetValidation();
        },



    },
};
</script>

<style scoped>
.titlenewrow {
    justify-content: center;
    padding-top: 25px;
    padding-bottom: 30px;
    font-weight: bolder;
}

.v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none;
}
</style>

<style>
.cont_cespiti_admin_ok .cl_office_lic {
    width: 49px;
}

.cont_cespiti_admin_ok .cl_date_inv {
    width: 55px;
    transform: translateX(10px);
}


.cont_cespiti_admin_ok .cl_data_ora {
    margin-left: 4px;
}

.no-before::before {
    content: none !important;
}


table.dataTable.dtr-inline.collapsed>tbody>tr>td.dtr-control:before,
table.dataTable.dtr-inline.collapsed>tbody>tr>th.dtr-control:before {
    margin-right: 0.5em !important;
    display: block !important;
    box-sizing: content-box !important;
    content: "+" !important;
    color: white !important;
    top: 50% !important;
    left: 5px !important;
    height: 1em !important;
    width: 1em !important;
    margin-top: -9px !important;
    border: .15em solid white !important;
    border-radius: 1em !important;
    box-shadow: 0 0 .2em #444 !important;
    text-align: center !important;
    text-indent: 0 !important;
    font-family: "Courier New", Courier, monospace !important;
    line-height: 1em !important;
    background-color: #a4a4b0 !important;
    transform: translate(0px, 0px) !important;
}


.cont_cespiti_admin_ok #myTable_wrapper>.dt-layout-row:first-of-type {
    top: 66px;
    position: fixed;
    left: 0px;
    min-width: 100%;
    z-index: 3;
    background-color: white;
    border: 1px solid #ffd212;
    padding-left: 3px;
    padding-right: 3px;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-top: 0px;
}

.cont_cespiti_admin_ok .cl_num {
    margin-right: 11px !important;
}

.cl-checkbox {
    width: 13px !important;
    height: 13px !important;
    min-width: 13px !important;
    min-height: 13px !important;
}


canvas {
    border: 1px solid #c7c4a9;
    margin-top: 10px;
}

#container-view-pdf {
    display: flex;
    flex-direction: column;
    align-items: center;
}



.cont_cespiti_admin_ok .selnoleggio {
    max-width: 22px;
    min-height: 22px;
    margin-left: 9px;
    color: black !important;
    padding: 0px 0px;
    min-width: 14px !important;
    text-indent: -119px;
    background-size: 19px;
    background-repeat: no-repeat;
    z-index: 2;
    border: none !important;
    cursor: pointer;
}

.cont_cespiti_admin_ok .selfirma {
    max-width: 29px;
    min-height: 29px;
    margin-left: 9px;
    color: black !important;
    padding: 0px 0px;
    min-width: 14px !important;
    text-indent: -119px;
    background-size: 29px;
    background-repeat: no-repeat;
    z-index: 2;
    border: none !important;
    cursor: pointer;
}


.goToNonAssegnati {
    cursor: pointer;
}

.dataTable tbody tr,
.dataTable tbody tr td {
    vertical-align: middle;
    padding: 6px !important;
}

.pay {
    display: flex;
    justify-content: center;
    padding-top: 10px;
    color: #f5cf2e;

}

.pay a {
    color: #f5cf2e;

    -webkit-transition: background-color 2s ease-out;
    -moz-transition: background-color 2s ease-out;
    -o-transition: background-color 2s ease-out;
    transition: background-color 2s ease-out;

}

.pay a:hover {
    color: #f5cf2e;
}

.plan {
    margin-top: 20px;
    font-size: 12px;
    display: flex;
    justify-content: center;

}

.policy {
    text-align: center;
    margin-top: 30px;
}

.version {
    font-size: 10px;
    margin-top: 25px;
    text-align: center;
}

.version span {
    font-size: 13px;
}

.titleproduct {
    font-size: 16px;
    font-size: 16px;
    color: #rgb(245, 207, 46);
    font-weight: 800;

    text-align: center;
    margin-top: 40px;

}

.Absolute-Center {

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    bottom: 0;
    height: 100px;
    left: 0;
    margin: auto;
    position: absolute;
    top: 0;
    right: 0;
    width: 300px;
}

.logo {
    text-align: center;
}


ion-items {
    min-width: 60px;

}

ion-items ion-datetime {
    margin-left: 25px;
}

.colcontTable .col-sm-12 {
    padding:
        0px;
}

.selectpianiall {
    max-width: 21px;
    min-height: 22px;
    margin-left: 0px;
    color: black !important;
    padding: 0px 0px;
    min-width: 14px !important;
    /* border-radius: 12px; */
    /* min-height: 12px; */
    /* transform: translateY(-2px); */
    background-image: url(/smartb/img/FiltroNucleo.png);
    /* padding: 1px 11px; */
    text-indent: -119px;
    background-size: 19px;
    background-repeat: no-repeat;
    transform: translateY(2px);
}


.cont-table .spin {

    display: flex;
    position: absolute;
    z-index: 100;
    min-width: 100vw;
    min-height: 100vh;
    left: 0;
    top: 0;
    align-items: center;
    justify-content: center;
}


.cont_cespiti_admin_ok table.dataTable.dtr-inline.collapsed>tbody>tr>td.dtr-control,
.cont_cespiti_admin_ok table.dataTable.dtr-inline.collapsed>tbody>tr>th.dtr-control {
    padding-left: 25px !important;
    /* padding-bottom: 9px !important; */
}

.cont_cespiti_admin_ok th {
    padding-left: 5px !important;
}

.cont_cespiti_admin_ok ion-datetime.dateBook {
    margin-left: 16px;
}


.cont_cespiti_admin_ok .selaggiorna {
    max-width: 22px;
    min-height: 22px;
    margin-left: 9px;
    color: black !important;
    padding: 0px 0px;
    min-width: 14px !important;
    text-indent: -119px;
    background-size: 19px;
    background-repeat: no-repeat;
    z-index: 2;
    border: none !important;
    cursor: pointer;
}


.cont_cespiti_admin_ok .table-responsive {
    padding: 0px;
    min-width: 90vw;
    max-width: 100vw;
}


.cont_cespiti_admin_ok #myTable_filter {
    position: fixed;
    left: 0px;
    min-width: 100%;
    z-index: 3;
    background-color: white;
    border-color: #f5cf2e;

}

.cont_cespiti_admin_ok div.dataTables_wrapper div.dataTables_filter input {
    /* margin-top:5px!important */
}

.cl-date {
    font-size: 10px;
    color: gray;
}

.cont_cespiti_admin_ok #myTable_wrapper {
    padding-top: 0px;
    min-width: 1100px !important;
    max-width: 1100px !important;
    width: 1100px !important;
}

.cont_cespiti_admin_ok #myTable {
    margin-right: 3px;
    width: 1085px !important;
}


.cont_cespiti_admin_ok .text_title {
    background-color: white;
    color: black;
    font-weight: bold;
    padding-top: 4px;
    padding-bottom: 4px;
    padding-left: 0px;
    font-size: 10px;
    min-width: 0vw
}

.cont_cespiti_admin_ok .cl_active {
    display: inline-flex;
    align-items: center;
    min-width: 100%;
    justify-content: center;
}

.cont_cespiti_admin_ok .selectstatusall {
    max-width: 21px;
    min-height: 22px;
    margin-left: 0px;
    color: black !important;
    padding: 0px 0px;
    min-width: 14px !important;
    background-image: url(/emt/img/Filtro.png);
    text-indent: -119px;
    background-size: 24px !important;
    background-repeat: no-repeat;
    transform: translateY(2px);
    margin-top: -5px !important;

}


.cont_cespiti_admin_ok .cont_buttons {
    display: flex !important;
    align-items: center !important;
    float: left !important;
    min-width: 95px !important;
    padding-left: 10px !important;
    justify-content: inherit !important;
}

.action-sheet-button-inner.sc-ion-action-sheet-ios {
    color: black !important;
}

.closeStatusSheet {
    position: absolute;
    right: 0;
}

.selfiltri {
    max-width: 23px;
    min-height: 23px;
    margin-left: 9px;
    color: black !important;
    padding: 0px 0px;
    min-width: 14px !important;
    text-indent: -119px;
    background-size: 19px;
    background-repeat: no-repeat;
    z-index: 2;
    border: none !important;
    cursor: pointer;

}



.selassegnamento {
    max-width: 29px;
    min-height: 29px;
    margin-left: 9px;
    color: black !important;
    padding: 0px 0px;
    min-width: 29px !important;
    text-indent: -119px;
    background-size: 29px;
    background-repeat: no-repeat;
    z-index: 2;
    border: none !important;
    cursor: pointer;

}





.cont_cespiti_admin_ok .selazienda {
    max-width: 23px;
    min-height: 23px;
    margin-left: 9px;
    color: black !important;
    padding: 0px 0px;
    min-width: 14px !important;
    text-indent: -119px;
    background-size: 23px;
    background-repeat: no-repeat;
    z-index: 2;
    border: none !important;
    cursor: pointer;
}


.headerSheetAziende {
    position: fixed;
    z-index: 2;
    min-width: 100vw;
    background: white;
}


.itemAzienda {
    margin-left: 15px;
}

.v-application .text-center {

    overflow: auto;
}

.cont_cespiti_admin_ok .clDataDa {
    font-weight: bold;
    transform: translate(6px, -12px);
}

.cont_cespiti_admin_ok .clValueDataDa {
    font-weight: bold;
    transform: translate(11px, -11px);
}

.cont_cespiti_admin_ok .seldata {
    max-width: 27px;
    min-height: 27px;
    margin-left: 11px;
    color: black !important;
    padding: 0px 0px;
    min-width: 14px !important;
    text-indent: -119px;
    background-size: 27px;
    background-repeat: no-repeat;
    z-index: 2;
    border: none !important;
    cursor: pointer;
    margin-top: --2px;
}

.cont_cespiti_admin_ok .selricerca {
    max-width: 31px;
    min-height: 31px;
    margin-left: 9px;
    color: black !important;
    padding: 0px 0px;
    min-width: 14px !important;
    text-indent: -119px;
    background-size: 19px;
    background-repeat: no-repeat;
    z-index: 2;
    border: none !important;
    cursor: pointer;
    margin-right: 14px !important;
    float: right;
}


.cont_cespiti_admin_ok .cl_checkall {
    padding-left: 1px;
    padding-top: 2px;
}

.cont_cespiti_admin_ok .checkall {
    width: 13px;
    height: 13px;
}

.cl-allegato {
    text-align: center;
    margin-left: 6px;
}

.cont_cespiti_admin_ok .cl-stato {
    text-align: center;
}

.cont_cespiti_admin_ok .val_status {
    width: 10px !important;
}


@media screen and (max-width: 960px) {

    .cl_note {
        display: inline;
    }

    .cont_cespiti_admin_ok .cl_active {
        display: contents;
        align-items: center;
        justify-content: flex-start;
        text-align: center;
    }


    .cont_cespiti_admin_ok #myTable_filter {
        top: 56px;
        position: fixed;

    }

}

@media screen and (max-width: 1024px) {

    .contIcon {
        display: inherit;
    }



    .cont_cespiti_admin_ok #myTable {
        max-width: 100vw !important;
        margin-right: 0px;
        min-width: 100vw !important;
        position: relative;
        width: 100vw !important;

    }

    .cont_cespiti_admin_ok #myTable_filter {
        top: 56px;
        position: fixed;

    }

    .cont_cespiti_admin_ok .table-responsive {
        padding: 0px;
        min-width: 100vw !important;
        max-width: 100vw !important;
        left: 0px;
        position: fixed;

    }

    .cont_cespiti_admin_ok #myTable_wrapper {
        min-width: initial;
        min-width: 100vw !important;
        max-width: 100vw !important;
        width: 100vw !important;
        overflow-x: auto !important;
    }

    .cont_cespiti_admin_ok .cl_num {
        margin-left: -2px !important;
    }

    .cl_n_matricola {
        display: inline-flex;
    }

    .cl_desc_project {
        display: inline-flex;
    }

    .cl_costo_giornaliero {
        display: inline-flex;
    }

    .cl_diaria {
        display: inline-flex;
    }

    .cl_ticket {
        display: inline-flex;
    }

    .cl_piano_orario {
        display: inline-flex;
    }

    .cl_ebadge {
        display: inline-flex;
    }

    .cl_totale_ferie {
        display: inline-flex;
    }

    .cont_cespiti_admin_ok .cl_checkall {
        padding-left: 2px;
        padding-top: 2px;
    }

    .cont_cespiti_admin_ok .cl-allegato {
        text-align: center !important;
        display: block !important;
    }

    .cont_cespiti_admin_ok .cl-stato {
        text-align: center !important;
        display: block !important;
    }


}
</style>
